var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfiguration01 = function SvgConfiguration01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.91,
    y1: 154.15,
    x2: 175.65,
    y2: 15.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -37.64,
    y1: 107.41,
    x2: 138.92,
    y2: -31.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 32.1,
    y1: 196.18,
    x2: 208.67,
    y2: 57.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -4.62,
    y1: 149.43,
    x2: 171.94,
    y2: 10.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 62.85,
    y1: 235.31,
    x2: 239.41,
    y2: 96.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 26.12,
    y1: 188.56,
    x2: 202.69,
    y2: 49.83,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M185.71,46.43h-84.57c-1.97,0-3.57,1.6-3.57,3.57s1.6,3.57,3.57,3.57h84.57c7.89,0,14.29-6.4,14.29-14.29s-6.4-14.29-14.29-14.29h-84.57c-1.97,0-3.57,1.6-3.57,3.57s1.6,3.57,3.57,3.57h84.57c3.94,0,7.14,3.2,7.14,7.14s-3.2,7.14-7.14,7.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.29,53.57h21.69c4.94,8.54,14.17,14.29,24.74,14.29,15.78,0,28.57-12.79,28.57-28.57s-12.79-28.57-28.57-28.57c-10.57,0-19.8,5.75-24.74,14.29H14.29c-7.89,0-14.29,6.4-14.29,14.29s6.4,14.29,14.29,14.29ZM60.71,17.86c11.83,0,21.43,9.59,21.43,21.43s-9.59,21.43-21.43,21.43-21.43-9.59-21.43-21.43,9.59-21.43,21.43-21.43ZM14.29,32.14h18.76c-.59,2.28-.9,4.68-.9,7.14s.31,4.86.9,7.14H14.29c-3.94,0-7.14-3.2-7.14-7.14s3.2-7.14,7.14-7.14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M185.71,85.71h-14.55c-4.94-8.54-14.17-14.29-24.74-14.29-15.78,0-28.57,12.79-28.57,28.57s12.79,28.57,28.57,28.57c10.57,0,19.8-5.75,24.74-14.29h14.55c7.89,0,14.29-6.4,14.29-14.29s-6.4-14.29-14.29-14.29ZM146.43,121.43c-11.83,0-21.43-9.59-21.43-21.43s9.59-21.43,21.43-21.43,21.43,9.59,21.43,21.43-9.59,21.43-21.43,21.43ZM185.71,107.14h-11.61c.59-2.28.9-4.68.9-7.14s-.31-4.86-.9-7.14h11.61c3.94,0,7.14,3.2,7.14,7.14s-3.2,7.14-7.14,7.14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.29,114.29h91.71c1.97,0,3.57-1.6,3.57-3.57s-1.6-3.57-3.57-3.57H14.29c-3.94,0-7.14-3.2-7.14-7.14s3.2-7.14,7.14-7.14h91.71c1.97,0,3.57-1.6,3.57-3.57s-1.6-3.57-3.57-3.57H14.29c-7.89,0-14.29,6.4-14.29,14.29s6.4,14.29,14.29,14.29Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.71,146.43h-59.57c-1.97,0-3.57,1.6-3.57,3.57s1.6,3.57,3.57,3.57h59.57c3.94,0,7.14,3.2,7.14,7.14s-3.2,7.14-7.14,7.14h-59.57c-1.97,0-3.57,1.6-3.57,3.57s1.6,3.57,3.57,3.57h59.57c7.89,0,14.29-6.4,14.29-14.29s-6.4-14.29-14.29-14.29Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85.71,132.14c-10.57,0-19.8,5.75-24.74,14.29H14.29c-7.89,0-14.29,6.4-14.29,14.29s6.4,14.29,14.29,14.29h46.69c4.94,8.54,14.17,14.29,24.74,14.29,15.78,0,28.57-12.79,28.57-28.57s-12.79-28.57-28.57-28.57ZM14.29,167.86c-3.94,0-7.14-3.2-7.14-7.14s3.2-7.14,7.14-7.14h43.76c-.59,2.28-.9,4.68-.9,7.14s.31,4.86.9,7.14H14.29ZM85.71,182.14c-11.83,0-21.43-9.59-21.43-21.43s9.59-21.43,21.43-21.43,21.43,9.59,21.43,21.43-9.59,21.43-21.43,21.43Z"
  })));
};
export default SvgConfiguration01;